import { ArrowRight, Check } from 'lucide-react';
import { getEventModuleLabel } from '@conference/shared';
import type { EventBuilderTemplate } from '../services/eventBuilderService';
import { Button, Modal } from './ui';

export default function EventBuilderTemplateComparison({
  open,
  templates,
  selectedKey,
  onClose,
  onSelect,
}: {
  open: boolean;
  templates: EventBuilderTemplate[];
  selectedKey: string | null;
  onClose: () => void;
  onSelect: (key: string) => void;
}) {
  return <Modal
    open={open}
    onClose={onClose}
    title="Choose a starting template"
    description="Templates set the first attendee experience. You can still change every module later."
    size="xl"
  >
    <div className="mb-3 grid grid-cols-2 gap-4 border-b border-gray-800 pb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-500">
      <span>Best for</span>
      <span>Attendee experience</span>
    </div>
    <div className="max-h-[65vh] space-y-3 overflow-y-auto pr-1">
      {templates.map((template) => <article
        key={template.key}
        className={`rounded-xl border p-4 ${selectedKey === template.key ? 'border-sky-500/60 bg-sky-500/5' : 'border-gray-800 bg-gray-950'}`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-white">{template.name}</h3>
              {selectedKey === template.key && <span className="inline-flex items-center gap-1 text-xs text-sky-300"><Check size={12} /> Current</span>}
            </div>
            <p className="mt-1 text-sm text-gray-400">{template.description}</p>
          </div>
          <Button
            size="sm"
            variant={selectedKey === template.key ? 'secondary' : 'primary'}
            onClick={() => onSelect(template.key)}
          >
            Preview {template.name}
          </Button>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
          <p className="text-gray-300">{template.best_for}</p>
          <div>
            <div className="flex flex-wrap items-center gap-1.5 text-xs text-sky-200">
              {template.destinations.map((destination, index) => <span key={destination} className="inline-flex items-center gap-1.5">
                {index > 0 && <ArrowRight size={11} className="text-gray-600" />}
                {destination}
              </span>)}
            </div>
            <p className="mt-2 text-xs text-gray-500">
              {template.module_keys.map((key) => getEventModuleLabel(undefined, key as never)).join(' · ')}
            </p>
          </div>
        </div>
      </article>)}
    </div>
  </Modal>;
}
